import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "custom-dropdown" }
const _hoisted_2 = {
  key: 0,
  class: "dropdown-menu w-full mt-1 bg-gray-700 border border-gray-600 rounded-md max-h-60 overflow-y-auto absolute z-10"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-1" }, "Kategorija", -1)),
    _createElementVNode("div", {
      class: "dropdown-toggle w-full bg-gray-700 border border-gray-600 rounded-md py-2 px-3 text-white focus:outline-none focus:ring-2 focus:ring-green-500 flex justify-between items-center cursor-pointer",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = !_ctx.isOpen))
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.selectedCategoryName || 'Sve kategorije'), 1),
      _cache[2] || (_cache[2] = _createElementVNode("svg", {
        class: "w-4 h-4 text-gray-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 9l-7 7-7-7"
        })
      ], -1))
    ]),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "py-2 px-3 hover:bg-gray-600 cursor-pointer border-b border-gray-600 text-white",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCategory('', '')))
          }, " Sve kategorije "),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
            return (_openBlock(), _createElementBlock("div", {
              key: category.id
            }, [
              _createElementVNode("div", {
                class: "py-2 px-3 hover:bg-gray-600 cursor-pointer text-white font-medium",
                onClick: ($event: any) => (_ctx.selectCategory(category.id, category.name))
              }, _toDisplayString(category.name), 9, _hoisted_3),
              (category.children && category.children.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.children, (child) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: child.id,
                        class: "py-1.5 pl-8 pr-3 hover:bg-gray-600 cursor-pointer text-white text-sm",
                        onClick: ($event: any) => (_ctx.selectCategory(child.id, child.name))
                      }, _toDisplayString(child.name), 9, _hoisted_5))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}